import { AbilityContext } from '@src/utility/context/Can'
import React, { useContext, useState } from 'react'
import { ArrowLeft, Download, File, FileText, Filter, List, Tool } from 'react-feather'
import { useDispatch } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Button, Card, CardHeader, CardTitle, Col, DropdownItem, DropdownMenu, DropdownToggle, Input, UncontrolledButtonDropdown, UncontrolledDropdown } from 'reactstrap'
import { handleCleanForm } from '../../../redux/actions/form'
import { FilterContext } from '../../../utility/context/FilterContext'
import { AdvancedFilter } from './addons/AdvancedFilter'
import CustomFilter from './addons/CustomFilter'
import { downloadCSV } from './addons/DownloadCSV'
import { keyValueSelector } from './functions'

export const TableHeader = (props) => {
    const dispatch = useDispatch()

    const {
        title,
        can,
        redirPath,
        addButton = true,
        backButton = false,
        addFunction = () => dispatch(handleCleanForm()),
        massiveUpload = false,
        filters,
        columns,
        data = [],
        realData = [],
        endPoint,
        params,
        modalForm,
        listCollection,
        options = []
    } = props

    const ability = useContext(AbilityContext)
    const history = useHistory()

    const [showAdvanced, setShowAdvanced] = useState(false)
    const [showFilters, setShowFilters] = useState(false)
    const [statusModal, setStatusModal] = useState(false)

    const {
        searchColumnValue, setColumnValue, setFilteredData,
        searchGlobalValue, setGlobalSearchValue,
        setCurrentPage, showStoredData, store
    } = useContext(FilterContext)
    const pathname = useLocation().pathname
    const isAdd = pathname.slice(-3) === 'add'

    const refreshFilters = () => {
        setShowFilters(!showFilters)
        setColumnValue({})
        setFilteredData([])
    }

    const refreshAdvancedFilters = () => { setShowAdvanced(!showAdvanced) }

    const updateFilterData = (columnFilter, globalFilter) => {
        const updateData = data.filter(dataItem => {
            let filtered
            return Object.keys(columnFilter).every(FilterKey => {
                if (columnFilter[FilterKey].length === 2) {
                    if (columnFilter[FilterKey][0] !== '' && columnFilter[FilterKey][1] !== '') {
                        const valueDate = new Date(keyValueSelector(FilterKey, dataItem)).getTime()
                        const startFilterDate = new Date(columnFilter[FilterKey][0]).getTime()
                        const endFilterDate = new Date(columnFilter[FilterKey][1]).getTime()

                        filtered = (startFilterDate <= valueDate && valueDate <= endFilterDate)
                    } else {
                        filtered = true
                    }
                } else {
                    switch (typeof columnFilter[FilterKey][0]) {
                        case 'number':
                            filtered = (columnFilter[FilterKey].every(value => String(keyValueSelector(FilterKey, dataItem)).toLowerCase().startsWith(value)))
                            break
                        case 'string':
                            if (columnFilter[FilterKey]?.length === 2) {
                                if (columnFilter[FilterKey][0] !== '' && columnFilter[FilterKey][1] !== '') {
                                    filtered = new Date(keyValueSelector(FilterKey, dataItem)).getTime() <= new Date(columnFilter[FilterKey][1]).getTime() && new Date(keyValueSelector(FilterKey, dataItem)).getTime() >= new Date(columnFilter[FilterKey][0]).getTime()
                                } else return true
                            } else filtered = (columnFilter[FilterKey].every(value => String(keyValueSelector(FilterKey, dataItem)).toLowerCase().indexOf(value?.toLowerCase()) !== -1))
                            break
                        case 'boolean':
                            filtered = (columnFilter[FilterKey].every(value => String(keyValueSelector(FilterKey, dataItem)).toLowerCase().startsWith(value)))
                            break
                        default:
                    }
                }
                return filtered
            })
        })
        if (globalFilter) {
            updateData.filter(dataItem => Object.keys(dataItem).some(FilteredKey => console.log(dataItem, FilteredKey)))
            setFilteredData(updateData.filter(dataItem => Object.keys(dataItem).some(FilteredKey => String(dataItem[FilteredKey]).toLowerCase().includes(globalFilter?.toLowerCase()))))
        } else {
            setFilteredData(updateData)
        }
    }

    const handleFilter = (id, values, isSelect = false) => {
        const updateGlobalFilter = (id === 'globalFilter')

        const globalFilter = updateGlobalFilter ? values : searchGlobalValue
        const columnFilter = updateGlobalFilter ? searchColumnValue : { ...searchColumnValue, [id]: values }

        if (!updateGlobalFilter) values = values.filter(value => (value !== undefined) && value.length !== 0)
        if (!updateGlobalFilter && values.length === 0) delete columnFilter[id]

        setColumnValue(columnFilter || [])
        setGlobalSearchValue(globalFilter || [])
        setCurrentPage(0)
        updateFilterData(columnFilter, globalFilter)
    }

    const handleOption = (callback, params) => {
        const { reload } = params
        callback()
        if (reload) history.go(0)
    }


    return (
        <>
            {
                (filters && showAdvanced) && (<Card><AdvancedFilter endPoint={endPoint} title={title} filters={filters} params={params} /></Card>)
            }
            <CardHeader className='flex-md-row flex-column align-items-center align-items-start border-bottom px-0'>
                <Col>
                    <CardTitle tag='h4' className="pl-0">{title}</CardTitle>
                </Col>
                <Col style={{ textAlign: 'right', display: ' contents' }}>
                    {options.length > 0 && (
                        <UncontrolledDropdown>
                            <DropdownToggle className='pr-1' tag='span'>
                                <Button.Ripple className="float-back mx-25" color='secondary' style={{ marginRight: '10px' }}>
                                    <span className='align-middle'>Opciones</span>
                                </Button.Ripple>
                            </DropdownToggle>
                            <DropdownMenu right>
                                {
                                    options.map(({ OptionComponent, ...o }, i) => !!OptionComponent
                                        ? <OptionComponent key={`customOptionComponent_${i}`} {...o} />
                                        : (
                                            <DropdownItem key={`customOption_${i}`} tag='a' className='w-100' onClick={() => handleOption(o.function, o)}>
                                                <o.icon size={12} />
                                                <span className='align-middle ml-50'>{o.name}</span>
                                            </DropdownItem>
                                        )
                                    )
                                }

                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}

                    {/* <Button className='mr-1 border' outline={!store} onClick={showStoredData}>
                        Archivado
                    </Button> */}
                    {filters &&
                        (
                            <>
                                {/* <Button className='mr-1 border' outline={!showAdvanced} color={showAdvanced ? 'primary' : ''} onClick={refreshAdvancedFilters}>
                                    <Layers className='p-0' size={12} />
                                </Button> */}
                                <Button className='mr-1 border btn btn-xs' outline={!showFilters} color={showFilters ? 'primary' : ''} onClick={refreshFilters}>
                                    <Filter size={12} />
                                </Button>
                            </>
                        )
                    }
                    <Input className='dataTable-filter mr-2' type='text' placeholder='Buscar' bsSize='xl' onChange={(e) => handleFilter('globalFilter', e.target.value)} style={{ maxWidth: '20%' }} />
                    <UncontrolledButtonDropdown className='mr-2'>
                        <DropdownToggle color='secondary' outline >
                            <Tool size={15} />
                        </DropdownToggle>
                        <DropdownMenu right>
                            <DropdownItem toggle={null} className='w-100' onClick={() => downloadCSV(title, realData)}>
                                <Download size={15} />
                                <span className='align-middle ml-50'>CSV</span>
                            </DropdownItem>
                            {(massiveUpload) &&
                                <>
                                    <DropdownItem toggle={null} className='w-100' onClick={() => downloadOT('/workOrders/listDownload/')}>
                                        <List size={15} />
                                        <span className='align-middle ml-50'>Imprimir Lista</span>
                                    </DropdownItem>
                                    <DropdownItem toggle={null} className='w-100' onClick={() => downloadOT('/workOrders/documnetDownload/')}>
                                        <File size={15} />
                                        <span className='align-middle ml-50'>Imprimir Documentos</span>
                                    </DropdownItem>
                                    <DropdownItem toggle={null} className='w-100' onClick={() => deliveryOT()}>
                                        <FileText size={15} />
                                        <span className='align-middle ml-50'>Generar Albaranes</span>
                                    </DropdownItem>
                                </>
                            }
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    {
                        backButton && (
                            <Link to='#' onClick={() => { history.goBack() }}>
                                <Button className='mr-2' color='secondary' outline>
                                    <ArrowLeft size={15} />
                                    <span className='align-middle ml-50'>Atrás</span>
                                </Button>
                            </Link>
                        )
                    }
                </Col>
            </CardHeader>
            {showFilters && (
                <div style={{ display: 'flex', marginTop: '0.5%', marginBottom: '0.5%', height: '2.1rem' }}>
                    <CustomFilter columns={columns} searchColumnValue={searchColumnValue} handleFilter={handleFilter} areFiltersActive={showFilters} />
                </div>)}
        </>
    )
}
